export default __webpack_public_path__ + "static/media/consulting.9fdfa514.jpg";